// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import prodConfig from './config/config.prod';
import stagingConfig from './config/config.staging';

const getConfiguration = () => {
  if (typeof process !== 'undefined') {
    return process.env.APP_ENV_PROFILE === 'prod' ? prodConfig : stagingConfig;
  } else {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return window.env === 'prod' ? prodConfig : stagingConfig;
  }
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const environment = getConfiguration();
// export const environment = window.env === 'Prod' stagingConfig;

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
